<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title >
      @if (session && session.title) {
        <span>{{session.title}}</span>
      }
      @if (session && !session.title) {
        <span>{{event.title}}</span>
      }
      <p class="subtitle">Ticket types</p>
    </ion-title>
  </ion-toolbar>

</ion-header>

<ion-content scrollY="false">

  <div class="scroll-wrapper scroll-shadow">

    @if (ticket_types && ticket_types.length != 0) {
      <ion-list>
        @for (ticket_type of ticket_types; track ticket_type) {
          <ion-item detail="true" button="true" lines="full" (click)=ticketTypeClicked(ticket_type)>
            <ion-label>
              <h3 class="ion-text-wrap">{{ticket_type.title}}</h3>
              <ion-grid class="ion-no-padding">
                <ion-row>
                  @if (ticket_type.sell_price) {
                    <ion-col size="auto">
                      <h5>Price</h5>
                      <p class="prominent">{{cart.currency.sign}}{{ticket_type.sell_price | number:'1.2'}}</p>
                    </ion-col>
                  }
                  <ion-col size="auto">
                    <h5>Tickets sold</h5>
                    <p class="prominent">{{ticket_type.tickets_sold_count}}</p>
                  </ion-col>
                  @if (ticket_type.tickets_left_count) {
                    <ion-col size="auto">
                      <h5>Tickets left</h5>
                      <p class="prominent">
                        @if (ticket_type.tickets_left_count > ticket_type.low_ticket_threshold) {
                          <span class="success">{{ticket_type.tickets_left_count}}</span>
                        }
                        @if (ticket_type.tickets_left_count <= ticket_type.low_ticket_threshold && ticket_type.tickets_left_count > 0) {
                          <span class="warning">{{ticket_type.tickets_left_count}}</span>
                        }
                        @if (ticket_type.tickets_left_count != undefined && ticket_type.tickets_left_count <= 0) {
                          <span class="danger">{{ticket_type.tickets_left_count}}</span>
                        }
                      </p>
                    </ion-col>
                  }
                </ion-row>
              </ion-grid>
            </ion-label>
          </ion-item>
        }
      </ion-list>
    }

    @if (ticket_types && ticket_types.length == 0) {
      <ion-grid class="nothing-found">
        <ion-row class="ion-align-items-center ion-justify-content-center">
          <ion-col>
            <p>
              <fa-icon [icon]="['fal', 'ticket']" size="6x"></fa-icon>
              <span>No ticket types found</span>
            </p>
          </ion-col>
        </ion-row>
      </ion-grid>
    }

  </div>

</ion-content>